import React, { useState, createRef } from 'react';
import { TextareaField, Iconsvg, DragAndDrop, UploadStatus, FormFieldErrorInfo, SegmentedControl, SegmentedControlItem, InputField } from '@wk/components-react16';

const TryNowPrompt = ({ data }: any) => {
    const { selectedIndex, setSelectedIndex, documentText, setDocumentText, fileList, setFileList, documentUrl, setDocumentUrl } = data;
    const storyContainer = createRef<any>();
    let id = 0;


    const handleSegmentChange = (event: any) => {
        setSelectedIndex(event);
        if (event == 0) {
            setFileList([]);
            setDocumentUrl('');
        } else if (event == 1) {
            setDocumentText('');
            setDocumentUrl('');
        } else if (event == 2) {
            setDocumentText('');
            setFileList([]);
        }
    }

    const handleFilesChange = (event: any) => {
        const targetFiles = Array.isArray(event) ? event : Array.from(event.target.files);
        const newFileItems = targetFiles.map((file: File) => {
            const uiFile = {
                id: _nextId(),
                nativeFile: file,
                label: file.name,
                type: file.type,
                progress: 100,
            };
            return {
                ...uiFile,
                status: 'completed',
            };
        });

        const newFileList = [...fileList];
        setFileList([...newFileItems, ...newFileList]);
    }

    const handleFileItemClick = (file: any) => {
        if (file.status !== 'uploading') {
            setFileList(fileList.filter((f: any) => f.id !== file.id));
            const nativeInput =
                storyContainer.current.ownerDocument.querySelector(
                    'input[type="file"]'
                ) as HTMLInputElement;
            nativeInput.value = '';
        }
    }

    const _nextId = () => {
        id += 1;
        return 'i-' + id;
    }

    const getErrors = (): Array<FormFieldErrorInfo> => {
        return fileList.filter((f: any) => f.errorMsg).map((f: any) => ({ label: f.errorMsg, labelId: f.id }));
    }

    const getErrorIds = () => {
        return getErrors().map((e: any) => e.labelId).join(',');
    }

    const getIconName = (file: any) => {
        if (file.type.includes('pdf')) {
            return 'file-pdf';
        } else if (file.type.includes('jpeg') || file.type.includes('png')) {
            return 'photo';
        } else {
            return 'file';
        }
    }

    return (
        <>
            <div className="cg-field-header" style={{ fontSize: '0.875rem' }}>
                <label className="cg-field-label">Input Details for Try Prompt
                    <div className="cg-field-required-indicator"><span aria-hidden="true">*</span></div>
                </label>
            </div>
            <div className='custom-segmented-control'>
                <SegmentedControl
                    selectedIndex={selectedIndex}
                    controlMode={'controlled'}
                    onUserRequest={(event: any) => handleSegmentChange(event)}>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Text
                    </SegmentedControlItem>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Upload
                    </SegmentedControlItem>
                    <SegmentedControlItem slot="segmentedControlItem">
                        Document Url
                    </SegmentedControlItem>
                </SegmentedControl>
            </div>
            {selectedIndex == 0 ? (
                <div className="mb-15 mt-5">
                    <TextareaField labelFor="textarea-id-2" indicator="required">
                        <textarea style={{ height: '10rem' }}
                            id="textarea-id-2" name="documentText"
                            placeholder="Document Text"
                            onChange={(event: any) => setDocumentText(event.target.value)}
                            value={documentText}
                        ></textarea>
                    </TextareaField>
                </div>
            ) : null}
            {selectedIndex == 1 ? (
                <div className="mb-15 mt-5" ref={storyContainer}>
                    <DragAndDrop
                        acceptTypes=".xlsx,.docx,.json,.png,.jpg,.jpeg" size="medium"
                            onFilesChange={(event: any) => handleFilesChange(event)}>
                        <input
                            id="file-upload-001"
                            type="file"
                            name="file-upload"
                            multiple
                            accept=".xlsx,.docx,.json,.png,.jpg,.jpeg"
                            aria-describedby={getErrorIds()}
                            onChange={(event: any) => handleFilesChange(event)}
                            slot="dragAndDropInput"
                        />
                        {fileList.map((item: any, i: number) =>
                            <UploadStatus
                                key={i}
                                label={item.label}
                                status={item.status}
                                size={item.nativeFile.size}
                                progress={item.progress}
                                isCompact
                                onItemClick={() => handleFileItemClick(item)}
                                slot="dragAndDropListItem">
                                <Iconsvg name={getIconName(item)}></Iconsvg>
                            </UploadStatus>
                        )}
                    </DragAndDrop>
                    <div className='mt-5 wk-size-1 text-warning-emphasis'>Accepted formats: Excel, Word (DOCX), JSON, PNG, JPG/JPEG.</div>
                </div>
            ) : null}
            {selectedIndex == 2 ? (
                <div className="mb-15 mt-5">
                    <InputField labelFor="input-id-1-3" indicator="required">
                        <input
                            type="text" id="input-id-1-3" name="documentUrl"
                            placeholder="Document Url"
                            onChange={(event: any) => setDocumentUrl(event.target.value)}
                            value={documentUrl} autoComplete="off"
                        />
                    </InputField>
                </div>
            ) : null}
        </>
    );
};

export default TryNowPrompt;